// @flow

import * as React from 'react';
import {useState} from 'react';

type SwitcherChildArgs = {
  active: boolean,
  setActive: (active: boolean) => any,
  toggleActive: () => any,
};

type SwitcherProps = {|
  children: (args: SwitcherChildArgs) => React.Node,
  active?: boolean,
|};

export const Switcher = (props: SwitcherProps) => {
  const [active, setActive] = useState(props.active || false);
  return props.children({
    active,
    setActive,
    toggleActive: () => setActive((wasActive) => !wasActive),
  });
};
